import { useContext, useState, useEffect, useRef } from "react";
import { Storage } from "aws-amplify";
import { centsToLocalString } from "../shared/money";
import { AppContext } from "../contextProviders/AppContext";
import { Grid, Typography, useTheme } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import { useGetImage } from "./customHooks";
import ProductImage from "./ProductImage";

export default function CartProduct({ offer }) {
  const theme = useTheme();
  const { deleteProduct, mobileViewPort } = useContext(AppContext);
  const titleRef = useRef();
  const image = useGetImage(offer.vehicle.image);

  return (
    <Grid item xs={12} sx={{ marginY: "3px" }}>
      <Grid container direction={"row"}>
        <Grid
          item
          xs={2}
          sx={{
            height: "75px",
            width: "75px",

            justifyContent: "center",
            alignItems: "center",
          }}
          container
        >
          <ProductImage offer={offer} />
        </Grid>
        <Grid
          item
          xs={9}
          container
          sx={{
            alignItems: "center",
            paddingLeft: "10px",
          }}
        >
          <Grid container direction={"column"}>
            <Grid item xs={12}>
              <Grid item xs={11}>
                <Typography
                  align="left"
                  variant="body2"
                  style={{
                    color: theme.palette.primary.mainText,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                    minWidth: 0,
                  }}
                  noWrap
                >
                  {offer.vehicle.name}
                </Typography>
              </Grid>
              <Typography
                variant="body1"
                sx={{ color: theme.palette.primary.mainText }}
              >
                {centsToLocalString(offer.offerPrice, true)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
          xs={1}
        >
          <DeleteIcon
            sx={{
              color: theme.palette.secondary.text,
              cursor: "pointer",
              fontSize: 26,
            }}
            onClick={() => deleteProduct(offer)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
